import axios from 'axios';

// Single source of truth for the backend origin. Set REACT_APP_API_URL in
// .env.local for local/custom setups; falls back to localhost in dev and the
// production API in a built bundle.
const BACKEND_ORIGIN =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000'
    : 'https://gigflow-backend-g7ea.onrender.com');

export const API_URL = `${BACKEND_ORIGIN}/api`;

export const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (user.token) config.headers.Authorization = `Bearer ${user.token}`;
    } catch {
      // ignore malformed localStorage payloads
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);
